<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="02" :question="question"></QuestionTitle>
        <div class="container-70">
            <MultipleInput :img="img" :listOfInput="listOfInput" v-model="result"></MultipleInput>
            <div v-if="result!=null" @click="saveAndContinue('organisationBillets', JSON.stringify(result), './question-3')" class="btn-primary d-block w-100 mt-50px text-center" >Suivant</div>
            <AvancementLine percent="33%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import MultipleInput from '@/components/MultipleInput.vue'
import AvancementLine from '@/components/AvancementLine.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Sur une période de 1 an, combien votre organisation a dépensé ($) en billets de transport ?',
            img:require('@/assets/images/passenger.png'),
            listOfInput:[
                'Avion',
                'Train'
            ]
        }
    },
    components: {
        QuestionTitle,
        MultipleInput,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('organisationBillets')){
            this.result=JSON.parse(sessionStorage.getItem('organisationBillets'))
        }
    }
}
</script>